module.exports = __webpack_public_path__ + "img/led_in_switch_80.6421d5e0.png";